import type { Camp } from '@/payload-types'

export function getCampCategoryLabel(category: Camp['category'] | undefined | null): string {
  if (!category) return '—'
  if (typeof category === 'object' && category !== null && 'name' in category) {
    return category.name
  }
  return '—'
}

export function getCampYearFromDate(date: string | null | undefined): string {
  if (!date) return '—'
  return String(new Date(date).getFullYear())
}

export function formatCampTitleYearCategory(
  camp: Pick<Camp, 'title' | 'date' | 'category' | 'location'>,
): string {
  const year = getCampYearFromDate(camp.date)
  const category = getCampCategoryLabel(camp.category)
  return [camp.title, year, category, camp.location].filter(Boolean).join(' · ')
}
